import './CV.css';

function CV() {
  return (
    <div className="cv">
      <h1>Curriculum Vitae</h1>

      <section>
        <h2>Education</h2>
        <dl>
          <dt>2014</dt><dd>MFA Laguna College of Art and Design, Laguna Beach, CA</dd>
          <dt>2007</dt><dd>BFA Laguna College of Art and Design, Laguna Beach, CA</dd>
        </dl>
      </section>

      <section>
        <h2>Awards</h2>
        <dl>
          <dt>2013</dt><dd>Laguna College of Art and Design Grant</dd>
          <dt>2012</dt><dd>Laguna College of Art and Design Grant</dd>
          <dt>2009</dt><dd>Honorable Mention, Fairhaven Exhibition, Santa Ana, CA</dd>
          <dt>2007</dt><dd>Best of Show, LCAD, Laguna Beach, CA</dd>
          <dt>2006</dt><dd>Honorable Mention, United Society of Pastel Artists, Laguna Beach, CA</dd>
          <dt>2006</dt><dd>Best of Junior Drawing and Painting, LCAD, Laguna Beach, CA</dd>
          <dt>2005</dt><dd>Second Place, Saddleback Art League, Mission Viejo, CA</dd>
          <dt>2005</dt><dd>Plotkin Award, Lake Forest, CA</dd>
        </dl>
      </section>

      <section>
        <h2>Exhibits</h2>
        <dl>
          <dt>2015</dt><dd>Corpus Christi, Christ Cathedral, Garden Grove, CA</dd>
          <dt>2014</dt><dd>LCAD MFA Exhibit &mdash; Laguna Art Museum, Laguna Beach, CA</dd>
          <dt>2014</dt><dd>MFA Thesis Exhibition &mdash; Arena 1 Gallery, Santa Monica, CA</dd>
          <dt>2013</dt><dd>LCAD MFA Exhibit &mdash; Laguna Art Museum, Laguna Beach, CA</dd>
          <dt>2013</dt><dd>MFA City Hall Exhibit &mdash; Laguna Beach City Hall, Laguna Beach, CA</dd>
          <dt>2012</dt><dd>Scriptural Reflections &mdash; Blackfriar's Gallery, Dominican School, Berkeley, CA</dd>
          <dt>2011</dt><dd>Festival of Flowers &mdash; Saint Mary's Cathedral, San Francisco, CA</dd>
          <dt>2011</dt><dd>Sacred Art Exhibition &mdash; The National Shrine of Saint Francis, San Francisco, CA</dd>
          <dt>2009</dt><dd>Sacred Art Exhibit &mdash; Saint Victor's Catholic Church, West Hollywood, CA</dd>
          <dt>2009</dt><dd>JSerra Gala &mdash; San Juan Capistrano, CA</dd>
          <dt>2009</dt><dd>Visiting Exhibition &mdash; Bibo Gallery, Peoria, IL</dd>
          <dt>2008</dt><dd>Saint Michael's Gala &mdash; Marriott Fashion Island Hotel, Newport Beach, CA</dd>
          <dt>2008</dt><dd>10 under 30 &mdash; Sullivan Goss Gallery, Santa Barbara, CA</dd>
          <dt>2007</dt><dd>Saint Michael's Gala &mdash; Marriott Fashion Island Hotel, Newport Beach, CA</dd>
          <dt>2007</dt><dd>Mission Art Show &mdash; Mission San Juan Capistrano, San Juan Capistrano, CA</dd>
          <dt>2007</dt><dd>Rotating Exhibition &mdash; Seven Degrees Gallery, Laguna Beach, CA</dd>
          <dt>2007</dt><dd>Travels With Betty Exhibition &mdash; Kings Art Center, Hanford, CA</dd>
        </dl>
      </section>

      <section>
        <h2>Juried Shows</h2>
        <dl>
          <dt>2011</dt><dd>LCAD, 50th Anniversary Alumni Exhibit &mdash; 7 Degrees Gallery, Laguna Beach, CA</dd>
          <dt>2011</dt><dd>LPAPA's "Less Is More" &mdash; Randy Higbee Gallery, Costa Mesa, CA</dd>
          <dt>2007&ndash;10</dt><dd>Fairhaven Mausoleum Art Exhibition, Santa Ana, CA</dd>
          <dt>2009</dt><dd>Gallery 793, Laguna Beach, CA</dd>
          <dt>2003&ndash;08</dt><dd>LCAD Annual Summer Gallery, Laguna Beach, CA</dd>
          <dt>2007</dt><dd>Windows to the Divine, Denver, CO</dd>
          <dt>2003&ndash;07</dt><dd>LCAD Annual Student Show, Laguna Beach, CA</dd>
          <dt>2006</dt><dd>USPA Pastel Society Show, Laguna Beach, CA</dd>
          <dt>2006</dt><dd>Saddleback Art League Show, Mission Viejo, CA</dd>
          <dt>2005</dt><dd>Plotkin Foundation Show, Lake Forest, CA</dd>
        </dl>
      </section>

      <section>
        <h2>Permanent Collections</h2>
        <ul>
          <li>Papal Household, Vatican City</li>
          <li>Saints Peter and Paul Catholic Church, Los Angeles, CA</li>
          <li>Saint Thomas Aquinas Catholic Center, Purdue University, West Lafayette, IN</li>
          <li>Regis University, Denver, CO</li>
          <li>Saint Catherine's Catholic Church, Laguna Beach, CA</li>
          <li>The Busch Law Firm, Irvine, CA</li>
          <li>Private Collectors in United States and Europe</li>
        </ul>
      </section>

      <section>
        <h2>Publications</h2>
        <ul>
          <li>Saint Austin Review "Soul Journey" &mdash; September/October, 2014</li>
          <li>Our Sunday Visitor "Glimmer of Heaven" &mdash; July 31, 2012</li>
          <li>Saint Austin Review "Ink Desk" &mdash; May 2, 2012</li>
          <li>Catholic San Francisco "Saint Francis Shrine..." &mdash; January 12, 2012</li>
          <li>Coastline Pilot's In The Arts "Alumna's Painting at the Vatican" &mdash; August 19, 2011</li>
          <li>Saint Austin Review "Ink Desk" &mdash; November&ndash;December 2009</li>
          <li>The Laguna Beach Independent &mdash; December 1, 2007</li>
          <li>American Artist Magazine sketch work &mdash; August&ndash;September, 2007</li>
          <li>Coastline Pilot "Artist Emerge" &mdash; November 24, 2006</li>
        </ul>
      </section>

      <section>
        <h2>Charity</h2>
        <dl>
          <dt>2010&ndash;15</dt><dd>John Carroll Charity Event, Birmingham, AL</dd>
          <dt>2006&ndash;14</dt><dd>University Charity Event John Paul the Great University, San Diego, CA</dd>
          <dt>2013</dt><dd>Saint Paul Cathedral Gala, Birmingham, AL</dd>
          <dt>2013</dt><dd>Fundraiser for Church in Vietnam, Huntington Beach, CA</dd>
          <dt>2006&ndash;13</dt><dd>Collector's Choice Laguna College of Art &amp; Design, Laguna Beach, CA</dd>
          <dt>2009</dt><dd>Relay for Life, Portrait Drawing for Cancer Research, Dana Point, CA</dd>
        </dl>
      </section>

      <section>
        <h2>Teaching</h2>
        <dl>
          <dt>2007&ndash;15</dt><dd>Private Art Lessons</dd>
          <dt>2014&ndash;15</dt><dd>Saint John the Baptist School, Fine Art Instructor, Costa Mesa, CA</dd>
          <dt>2014</dt><dd>Teaching Assistant to Betty Shelton, Painting II</dd>
          <dt>2013</dt><dd>Teaching Assistant to Scott Settle, Perspective I</dd>
          <dt>2010</dt><dd>John Paul the Great University, Adjunct Professor, San Diego, CA</dd>
          <dt>2009</dt><dd>Silverleaf Academy of Art High School</dd>
        </dl>
      </section>

      <section>
        <h2>Television and Radio</h2>
        <dl>
          <dt>2015</dt><dd>EWTN Global Catholic Network, Life on the Rock, Birmingham, AL</dd>
          <dt>2015</dt><dd>Immaculate Heart Radio, Life on the Rock, Loomis, CA</dd>
        </dl>
      </section>
    </div>
  );
}

export default CV;
